import http from './api'

const route = 'payment/'

export default {
    show: (tokencontrato) => {
        return http.post(route + 'show', {
            tokencontrato: tokencontrato,
        })
    },

    showOptionClient: (username, tokencontrato) => {
        return http.post(route + 'get_payment_client', {
            username: username,
            tokencontrato: tokencontrato,
        })
    },

    endereco: (username, tokencontrato) => {
        return http.post(route + 'endereco', {
            username: username,
            tokencontrato: tokencontrato,
        })
    },
}
